import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=288d7290&scoped=true&"
import script from "./AlertView.vue?vue&type=script&lang=js&"
export * from "./AlertView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=288d7290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d7290",
  null
  
)

export default component.exports